function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.963 13.477l.117-.007c.513 0 .936.386.993.883l.007.117v1.99h1.99c.513 0 .936.386.993.883l.007.117c0 .513-.386.936-.883.993l-.117.007h-1.99v1.98c0 .513-.386.936-.883.993l-.117.007c-.513 0-.936-.386-.993-.883l-.007-.117v-1.98H15.1c-.513 0-.936-.386-.993-.883l-.007-.117c0-.513.386-.936.883-.993l.117-.007h1.98v-1.99c0-.513.386-.936.883-.993l.117-.007-.117.007zM2.93 8.1h18.14c.552 0 1 .448 1 1 0 .513-.386.936-.883.993l-.117.007H2.93c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L2.93 8.1h18.14H2.93z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.59 16.46H4.82c-.236 0-.462-.094-.63-.26-.166-.168-.26-.394-.26-.63V6.43c0-.492.398-.89.89-.89h14.36c.492 0 .89.398.89.89V12c0 .552.448 1 1 1s1-.448 1-1V6.43c0-1.596-1.294-2.89-2.89-2.89H4.82c-1.596 0-2.89 1.294-2.89 2.89v9.14c0 .766.304 1.502.846 2.044s1.278.846 2.044.846h5.77c.552 0 1-.448 1-1s-.448-1-1-1z"
}));

function SvgPaymentCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCard);
export default __webpack_public_path__ + "static/media/payment-card.9cedc87b.svg";
export { ForwardRef as ReactComponent };